// extracted by mini-css-extract-plugin
export default {"CreateUserDialog":"_6fhpuIlvSTeFgk3DB+X3OQ=="};